@import "../../../../globals/main.scss";

pn-level-up-modal {
    .pn-modal-header {
        z-index: 0;
    }

    .pn-modal {
        max-width: 63.1rem;

        @media screen and (max-width: $min-width-md) {
            height: 100%;
            max-height: 100%;
        }
    }

    .level-up-computer-modal .pn-modal-content .modal-content {
        justify-self: center;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        gap: 2em;
        margin: 2em;
        width: max-content;
        align-content: space-around;
    }

    .pn-modal-label {
        margin: 2.2rem 0;

        @media screen and (max-width: $min-width-md) {
            justify-self: center;
        }
    }

    .level-up-phone-modal .pn-modal-content {
        @media screen and (max-width: $min-width-md) {
            height: 100%;
            align-content: center;
            align-items: center;
        }
        
        pn-spinner {
            justify-self: center;
        }

        .modal-content-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 1em;

            @media screen and (max-width: $min-width-md) {
                flex-direction: column;
            }
        }

        .modal-content-list {
            ol {
                font-size: 1.8rem;
                line-height: 1.6;
                margin-left: 2rem;
                padding-left: 2rem;
            }

            li {
                margin-bottom: 1rem;
            }

            @media screen and (max-width: $min-width-md) {
                ol {
                    font-size: 1.6rem;
                }
            }
        }
    }
}